module.exports = __webpack_public_path__ + "img/banner transaction_success.57848c7c.jpg";